module.exports = __webpack_public_path__ + "static/assets/8bdce73195bf475057ff606ab3f6fffb.png";